module.exports = __webpack_public_path__ + "media/images/mobile/solutions/20-e6001287f779b67553bcb67692f47946.jpg";